export const buildPaginationQueryParams = (nodeParams: string) => `
totalCount
edges {
  cursor
  node {
    ${nodeParams}
  }
}
pageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
`;
